export function createDataContributors(contactID, contributor, email, creationDate, isValidated, canBeDeleted) {
    return { contactID, contributor, email, creationDate, isValidated, canBeDeleted }
}

export function createDataAccess(type, typeLabel, numRestaurantMCDO, pdl, label, address, hasAccess, index) {
    return { type, typeLabel, numRestaurantMCDO, pdl, label, address, hasAccess, index }
}

export function createDataMessages(messageID, sujet, message, dateCreation, dateModification, isRead) {
    return { messageID, sujet, message, dateCreation, dateModification, isRead }
}

export function createDataSepa(raisonSociale, sites, adresse, iban, ribFichier, mandatFichier, dateCreation, statut, ribID, mandatID, sepaId) {
    return { raisonSociale, sites, adresse, iban, ribFichier, mandatFichier, dateCreation, statut, ribID, mandatID, sepaId }
}

export function createDataSepaMcdo(raisonSociale, numRestaurantMCDO, sites, adresse, iban, ribFichier, mandatFichier, dateCreation, statut, ribID, mandatID, sepaId) {
    return { raisonSociale, numRestaurantMCDO, sites, adresse, iban, ribFichier, mandatFichier, dateCreation, statut, ribID, mandatID, sepaId }
}

export function createDataGreenEnergy(annee, libelle, period, nombreGO, attestationID) {
    return { annee, libelle, period, nombreGO, attestationID }
}

export function createDataElecInvoices(statut, numRestaurantMCDO, site, raisonSociale, adresse, prm, elecFournisseurNom, dateDebutFourniture, dateFinNouveauContrat, derniereFacture, anomalies, siteID) {
    return { statut, numRestaurantMCDO, site, raisonSociale, adresse, prm, elecFournisseurNom, dateDebutFourniture, dateFinNouveauContrat, derniereFacture, anomalies, siteID }
}

export function createDataInvoiceSitesVerification(numRestaurantMCDO, libelle, raisonSociale, prm, adresse, fournisseur, dateDebutFourniture, dateFinNouveauContrat, siteID) {
    return { numRestaurantMCDO, libelle, raisonSociale, prm, adresse, fournisseur, dateDebutFourniture, dateFinNouveauContrat, siteID }
}

export function createDataSites(appelOffre, numRestaurantMCDO, libelle, adresse, pce, prm, fournisseur, dateDebutFourniture, dateFinNouveauContrat, prixParMWh, consommation, facturation, prix, car, isConfirmed, etapeValidation, id, fromReengagement) {
    return { appelOffre, numRestaurantMCDO, libelle, adresse, pce, prm, fournisseur, dateDebutFourniture, dateFinNouveauContrat, prixParMWh, consommation, facturation, prix, car, isConfirmed, etapeValidation, id, fromReengagement }
}

export function createDataExcelSitesGaz(id, appelOffre, libelle, adresse, pce, fournisseur, dateDebutFourniture, dateFinNouveauContrat, prixParMWh, prix, car) {
    return { id, appelOffre, libelle, adresse, pce, fournisseur, dateDebutFourniture, dateFinNouveauContrat, prixParMWh, prix, car }
}

export function createDataExcelSitesElec(id, appelOffre, libelle, adresse, prm, fournisseur, dateDebutFourniture, dateFinNouveauContrat, prixParMWh, consommation, facturation, prix, car) {
    return { id, appelOffre, libelle, adresse, prm, fournisseur, dateDebutFourniture, dateFinNouveauContrat, prixParMWh, consommation, facturation, prix, car }
}

export function createDataWattvalueInvoices(type, periode, numRestaurantMCDO, libelle, raisonSociale, numFac, fichier, dateSignature, montantTTC, documentID, dateCreation) {
    return { type, periode, numRestaurantMCDO, libelle, raisonSociale, numFac, fichier, dateSignature, montantTTC, documentID, dateCreation }
}

export function createDataSitesConso(siteID, numRestaurantMCDO, libelle, raisonSociale, adresse, prm, periode, releveType, souscriptionType, dateFinAbonnement) {
    return { siteID, numRestaurantMCDO, libelle, raisonSociale, adresse, prm, periode, releveType, souscriptionType, dateFinAbonnement }
}

export function createDataTurpeSites(libelle, numRestaurantMCDO, adresse, prm, totalEconomie, datePublication, dateOptiApplication, dateOptiClient, isTurpeAlreadyOptimized) {
    return { libelle, numRestaurantMCDO, adresse, prm, totalEconomie, datePublication, dateOptiApplication, dateOptiClient, isTurpeAlreadyOptimized }
}
